
import { TAO_KOE, TaoConsole, TaoTrigger } from './../libs';

const exitIntentTriggered = () => {
	const DY = window.DY;

	TaoConsole.log( 'TRIGGER MOBILE EXIT INTENT' );

	if ( 'undefined' !== typeof DY ) {
		// Trigger custom Event.
		DY.API( 'event',
			{
				name: 'MOBILE_EXIT_INTENT',
				properties: {
					// Optional Properties.
				},
			},
		);
	}
};

TAO_KOE.ready( 'exit-intent.js', () => TaoTrigger.onExitIntent( () => exitIntentTriggered(), { delay: 20 } ) );
